import { useRef } from 'react';
import _ from 'lodash';

export function resolveOrgWidgetMeta(widgetsMetadata, widgetName) {
  const meta = widgetsMetadata && widgetsMetadata[widgetName];
  if (!meta) return null;
  return { ...meta, name: meta.name || widgetName };
}

export function useResolveOrgWidgetMeta(widgetsMetadata, widgetName) {
  const lastResolvedRef = useRef(null);
  const rawMeta = widgetsMetadata && widgetsMetadata[widgetName];
  const nextMeta = rawMeta ? { ...rawMeta, name: rawMeta.name || widgetName } : null;

  if (lastResolvedRef.current && _.isEqual(lastResolvedRef.current, nextMeta)) {
    return lastResolvedRef.current;
  }

  lastResolvedRef.current = nextMeta;
  return nextMeta;
}

export function getOrgWidgetTitle(title, meta) {
  return title || (meta && meta.title);
}
